export default "__VITE_ASSET__DzHj1gM___"